import ShareModal from '@app/components/ShareModal'
import { IShareContact } from '@app/models/ShareContact'
import { bindFunctions } from '@app/utils/class'
import { List } from 'immutable'
import * as React from 'react'
import { IShareFeedItemState, shareActionCreators } from '../modules/feedItems'

export interface IShareFeedItemModalProps {
  feedItemId: string
}

type ShareFeedItemModalProps = IShareFeedItemModalProps &
  IShareFeedItemState &
  typeof shareActionCreators

export class ShareFeedItemModal extends React.PureComponent<
  ShareFeedItemModalProps
> {
  constructor(props: ShareFeedItemModalProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    if (!this.props.shareItem) {
      return null
    }

    return (
      <ShareModal
        defaultContacts={this.props.shareItem.contacts}
        isLoading={this.props.shareItem.isLoading}
        isOpen={true}
        isSaving={this.props.shareItem.isSaving}
        onCancel={this._onCancelShare}
        onLoadDefaultContacts={this._onLoadModal}
        onShare={this._onShare}
        title='Share Feed Item'
      />
    )
  }

  private _onCancelShare() {
    if (this.props.shareItem) {
      this.props.cancelShareFeedItemModal(this.props.shareItem.feedItemId)
    }
  }

  private _onLoadModal() {
    this.props.loadShareFeedItem(this.props.feedItemId)
  }

  private _onShare(contacts: List<IShareContact>, comment: string) {
    if (this.props.shareItem) {
      this.props.shareFeedItem(this.props.shareItem, contacts, comment)
    }
  }
}
